export enum ThirdParty {
  WeChat,
  MiniProgram,
  QQ,
}
